<template>
  <b-modal
    visible
    centered
    hide-footer
    no-close-on-backdrop
    hide-header-close
    modal-class="iha-withdraw-modal"
  >
    <template #modal-header>
      <div class="view-clients-header">
        <b-button variant="close-btn" class="btn-container" @click="close">
          <i class="fas fa-times"></i>
        </b-button>
      </div>
    </template>
    <div >
        <div class="d-flex gap-3">
    <div class="icon-wrapper d-flex align-items-center justify-content-center ">
            <i class="fas fa-ban"></i>
        </div>
      <div class="text-container">
        <h5 class="mb-1 title-text">Withdraw Issue ?</h5>

        <p class="text-contentinfo m-0">
         This action cannot be undone and is only available before IHA responds.
        </p>
      </div>
        </div>
    

      <div class="d-flex justify-content-end gap-2 mt-4">
        <button class="btn btn-secondary fs-14" @click="close">Cancel</button>

        <button class="btn btn-danger fs-14" @click="withdrawIssue">Withdraw Issue</button>
      </div>
    </div>
  </b-modal>
</template>

<script>
export default {
  props: {
    row: Object,
  },

  methods: {
    close() {
      this.$emit("close");
    },

    withdrawIssue() {
      this.$emit("withdraw", this.row.id);
      this.$emit("close");
    },
  },
};
</script>
<style>
.iha-withdraw-modal .modal-header {
    padding: 6px 10px;
}
</style>
<style scoped>

.iha-withdraw-modal .icon-wrapper{
    width: 48px;
    height: 48px;
    border-radius: 50%;
    background-color: #F7D9DB;
    color: #DC3545;
    font-size: 20px;
    flex-shrink: 0;
}
.fs-14 {
  font-size: 14px;
}
.title-text{
    color: #2C3F58;
    font-size: 18px;
    font-weight: 600;
}
.text-contentinfo{
    color: #666666;
}
</style>
